<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    class="planEditor-div"
  >
    <div class="plan-form">
      <el-form size="mini" :rules="rules" :model="ruleForm" ref="ruleForm">
        <el-form-item label="预案名称:" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="预案类型:" prop="type">
          <el-select filterable allow-create v-model="ruleForm.type" placeholder="请选择">
            <el-option
              v-for="item in planOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="动作类型:" prop="action">
          <el-select class="hasBtn" v-model="action" placeholder="请选择">
            <el-option
              v-for="item in actionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button class="base-button" size="mini" type="primary" @click="addAction"
            >添加动作</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table
        :row-class-name="activeClass"
        height="450"
        stripe
        :data="tableData"
        style="width: 100%"
        class="outputTable"
      >
        <el-table-column label="序号" type="index" width="50"> </el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column prop="typeName" label="类型"> </el-table-column>
        <el-table-column prop="delay" label="延迟(秒)" width="120">
          <template slot-scope="scope">
            <el-input-number
              controls-position="right"
              :min="0"
              :step="0.1"
              size="mini"
              v-model="scope.row.delay"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column width="200" prop="order" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="setEdit(scope.row, scope.$index)" size="small"
              >编辑</el-button
            >
            <el-button type="text" @click="preAction(scope.row)" size="small"
              >向前</el-button
            >
            <el-button type="text" @click="nextAction(scope.row)" size="small"
              >向后</el-button
            >
            <el-button type="text" @click="setEffects(scope.row)" size="small"
              >特效</el-button
            >
            <!-- <el-button
              :disabled="scope.row && scope.row.data && scope.row.data.extType != '图标'"
              type="text"
              @click="setRoam(scope.row)"
              size="small"
              >漫游</el-button
            > -->
            <el-button type="text" @click="deleteAction(scope.row)" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="save-div">
      <el-button @click="preplanDeduction">预案推演</el-button>
      <el-button @click="timePlan">时间序列</el-button>
      <el-button @click="savePlan">保存预案</el-button>
      <el-button @click="clearPlan">清空预案</el-button>
    </div>
  </div>
</template>

<script>
/*******************UI*********************/
import com_point from "@/components/VectorPlot/compoent/point.vue";
import com_billboard from "@/components/VectorPlot/compoent/billboard.vue";
import com_line from "@/components/VectorPlot/compoent/line.vue";
import com_polygon from "@/components/VectorPlot/compoent/polygon.vue";
import com_polygon3 from "@/components/VectorPlot/compoent/polygon3.vue";
import com_circle from "@/components/VectorPlot/compoent/circle.vue";
import com_rectangle from "@/components/VectorPlot/compoent/rectangle.vue";
import com_ellipsoid from "@/components/VectorPlot/compoent/ellipsoid.vue";
import com_cylinder from "@/components/VectorPlot/compoent/cylinder.vue";
import com_wall from "@/components/VectorPlot/compoent/wall.vue";
import com_polylineVolume from "@/components/VectorPlot/compoent/polylineVolume.vue";
import com_svgEdit from "@/components/MilitaryPlot/svgEdit.vue";

import Actions from "./Actions/index.js";
import * as Help from "./Actions/help";
import Workflow from "./lib/Workflow";
import comRoam from "./Actions/com-roam.vue";
import Effects from "./Actions/effects.vue";
import videoTimeLine from "@/components/PlanEditor/videoTimeLine.vue";
import {
  createPlanEditor,
  queryPlanEditorList,
  queryBdthPlanById,
} from "@/api/planEditor/index.js";
import MilitarySimulation from "./Actions/militarySimulation.js";
export default {
  props: ["subData"],
  data() {
    return {
      action: "commonPlot",
      planOptions: [{ label: "作战模拟", value: "作战模拟" }],
      actionOptions: [
        { label: "常用标绘", value: "commonPlot" },
        { label: "军事标绘", value: "militaryPlot" },
        { label: "模型标绘", value: "pointModel" },
        { label: "场景书签", value: "sceneBookmark" },
        { label: "我的标绘", value: "myPlot" },
        // { label: "爆炸点", value: "pointExplot" },
        { label: "着火点", value: "ignitionPoint" },
        // { label: "扩散圆", value: "diffusionCircle" },
        // { label: "线路漫游", value: "lineRoam" },
        // { label: "直角箭头", value: "RightAngleArrow" }
      ],
      ruleForm: {
        name: "",
        type: "",
        actions: [],
        // id:"" //动作
      },
      rules: {},
      tableData: [],
      isEdit: false,
      loading: false,
      dragIndex: 0,
      newDragIndex: 0,
      timeSegments: [],
    };
  },

  created() {
    DBmap.plotUti.enableEdit(false);
    this.loading = false;
    if (this.subData) {
      this.isEdit = true;
      this.ruleForm.name = this.subData.planName;
      this.ruleForm.type = this.subData.planType;

      if (this.subData.listMain) {
        this.tableData = this.subData.listMain;
        return;
      }

      // this.tableData=this.subData.actions;
      queryBdthPlanById(this.subData.id)
        .then((res) => {
          this.tableData = res.result.detail.map((a) => {
            try {
              // 可能会引发异常的代码块
              a.data = JSON.parse(a.data);
            } catch (error) {
              // 异常处理代码块
            }

            a.view = JSON.parse(a.view);
            a.coordinate = JSON.parse(a.coordinate);
            a.params = JSON.parse(a.params);
            return a;
          });

          //绑定拖拽事件
          this.$nextTick(() => {
            const dragBox = document.querySelectorAll(".outputTable .isDragBox");
            dragBox.forEach((i, idx) => {
              i.setAttribute("draggable", "true");
              i.ondragstart = () => this.dragStartItem(idx);
              i.ondragover = () => this.dragOverItem(idx);
              i.ondragend = () => this.dragEndItem();
            });
          });
        })
        .catch((err) => {
          console.error(err);
        });
    }
  },
  mounted() {
    this.$bus.$on("addActionObj", this.addActionObj);
    this.$bus.$on("updateTableData", (list) => {
      this.tableData = list;
    });
  },
  updated() {
    //绑定拖拽事件
    this.$nextTick(() => {
      const dragBox = document.querySelectorAll(".outputTable .isDragBox");
      dragBox.forEach((i, idx) => {
        i.setAttribute("draggable", "true");
        i.ondragstart = () => this.dragStartItem(idx);
        i.ondragover = () => this.dragOverItem(idx);
        i.ondragend = () => this.dragEndItem();
      });
    });
  },
  beforeDestroy() {
    DBmap.plotUti.disableEdit();
    this.$bus.$off("addActionObj");
    this.$bus.$off("updateTableData");
  },

  methods: {
    generateRandomColor() {
      var letters = "0123456789ABCDEF";
      var color = "#";

      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }

      return color;
    },
    timePlan() {
      console.log(this.tableData);
      let startTime = 0;
      let endTime = 0;
      this.timeSegments = this.tableData.map((item, index) => {
        var delay = item.delay * 1000;
        item.continue = 1; //秒
        var continueTime = item.continue * 1000;

        startTime = index == 0 ? delay : endTime + delay;
        endTime = index == 0 ? startTime + continueTime : endTime + continueTime + delay;

        let s = {
          name: item.name,
          beginTime: startTime,
          endTime: endTime,
          color: this.generateRandomColor(),
          startRatio: 0.65,
          endRatio: 0.9,
          item: item,
        };

        return s;
      });

      this.$dialog.open({
        id: "时序列表",
        title: "时序列表",
        theme: "feature-dialog",
        area: {
          height: "40vh",
          width: "100vw",
        },
        location: {
          top: undefined,
          left: undefined,
          bottom: "20px",
          right: "0",
        },
        content: {
          type: "vue",
          subCom: videoTimeLine,
          subData: this.tableData,
        },
      });
    },
    activeClass({ row, rowIndex }) {
      if (rowIndex === this.newDragIndex) {
        return "isDragBox active-drag";
      }
      return "isDragBox";
    },
    dragStartItem(idx) {
      this.dragIndex = idx;
    },
    dragOverItem(index) {
      this.newDragIndex = index;
    },
    dragEndItem() {
      const data = this.tableData[this.dragIndex];
      this.tableData.splice(this.dragIndex, 1);
      this.tableData.splice(this.newDragIndex, 0, data);
    },
    savePlan() {
      this.loading = true;
      this.ruleForm.actions = this.tableData;
      console.log(this.ruleForm);

      let params = {};
      params.planName = this.ruleForm.name;
      params.planType = this.ruleForm.type;
      params.detail = this.ruleForm.actions.map((a) => {
        a.data = typeof a.data === "string" ? a.data : JSON.stringify(a.data);
        a.view = typeof a.view === "string" ? a.view : JSON.stringify(a.view);
        a.coordinate =
          typeof a.coordinate === "string" ? a.coordinate : JSON.stringify(a.coordinate);
        a.params = typeof a.params === "string" ? a.params : JSON.stringify(a.params);
        return a;
      });
      if (this.subData) {
        params.id = this.subData.id;
      }
      createPlanEditor(params)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "保存成功！",
              type: "success",
              duration: 3 * 1000,
            });
            this.$bus.$emit("PlanEditor-list");
            this.$parent.close();
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },
    clearPlan() {
      Help.clear();
    },
    //预案推演
    preplanDeduction() {
      MilitarySimulation.start(this.tableData, (diff) => {
        this.$bus.$emit("planStart", diff);
      });
      // Help.clear();
      // var list = this.tableData || [];
      // var funs = [];
      // for (let i = 0; i < list.length; i++) {
      //   funs.push({
      //     fun: this.createPromise,
      //     delay: list[i].delay * 1000,
      //     params: list[i],
      //   });
      // }

      // var ws = new Workflow(funs);
      // ws.runWorkflow();
    },

    createPromise(item) {
      item.complete = false;
      var type = item.type;
      let view = item.view;
      let opts = {};
      opts.destination = Cesium.Cartesian3.fromDegrees(view.x, view.y, view.z); //经度、纬度、高度
      opts.orientation = {
        heading: Cesium.Math.toRadians(Cesium.defaultValue(view.heading, 0)), //绕垂直于地心的轴旋转
        pitch: Cesium.Math.toRadians(Cesium.defaultValue(view.pitch, -90)), //绕纬度线旋转
        roll: Cesium.Math.toRadians(Cesium.defaultValue(view.roll, 0)), //绕经度线旋转
      };

      opts.complete = function () {
        item.complete = true;
      };

      return new Promise((resolve) => {
        viewer.camera.flyTo(opts);
        Help["action_" + type](item);
        let timer = setInterval(() => {
          if (item.complete) {
            resolve();
            clearInterval(timer);
          }
        }, 100);
      });
    },
    setEffects(obj) {
      this.$dialog.open({
        id: "添加特效",
        title: "添加特效",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: Effects,
          subData: obj,
        },
      });
    },
    setRoam(obj) {
      this.$dialog.open({
        id: "添加漫游",
        title: "添加漫游",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: comRoam,
          subData: obj,
        },
      });
    },
    setCameraView(obj) {},
    deleteAction(obj) {
      let arr = this.tableData;
      const index = arr.indexOf(obj);
      if (index > -1) {
        arr.splice(index, 1);
      }
    },
    preAction(obj) {
      let arr = this.tableData;
      const index = arr.indexOf(obj);
      if (index > 0) {
        arr.splice(index, 1);
        arr.splice(index - 1, 0, obj);
      }
    },
    nextAction(obj) {
      let arr = this.tableData;
      const index = arr.indexOf(obj);
      if (index < arr.length - 1) {
        arr.splice(index, 1);
        arr.splice(index + 1, 0, obj);
      }
    },
    addActionObj(obj) {
      obj.params = obj.params || {}; //动画参数
      obj.view = Help.getCameraView(); //位置
      this.tableData.push(obj);
    },
    addAction() {
      var commoent = Actions[this.action];
      var ins = this.$dialog.getDialog("添加动作" + commoent.name);
      if (ins) {
        ins.reset();
        return;
      }
      if (this.action == "myPlot") {
        this.$dialog.open({
          id: "添加动作" + commoent.name,
          title: "添加动作【" + commoent.name + "】",
          theme: "feature-dialog",
          area: {
            height: "800px",
            width: "600px",
          },
          location: {
            top: "80px",
            left: "20px",
          },
          content: {
            type: "vue",
            subCom: commoent.com,
            subData: null,
          },
        });
        return;
      }
      if (this.action == "militaryPlot") {
        this.$dialog.open({
          id: "添加动作" + commoent.name,
          title: "添加动作【" + commoent.name + "】",
          theme: "feature-dialog",
          area: {
            height: "800px",
            width: "600px",
          },
          location: {
            top: "80px",
            left: "20px",
          },
          content: {
            type: "vue",
            subCom: commoent.com,
            subData: "isPlanEditor",
          },
        });
        return;
      }

      this.$dialog.open({
        id: "添加动作" + commoent.name,
        title: "添加动作【" + commoent.name + "】",
        theme: "feature-dialog",
        area: {
          height: "auto",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: commoent.com,
          subData: null,
        },
      });
    },
    //编辑
    setEdit(row, index) {
      //回到这个位置
      let view = row.view;
      if (view) {
        let opts = {};
        opts.destination = Cesium.Cartesian3.fromDegrees(view.x, view.y, view.z); //经度、纬度、高度
        opts.orientation = {
          heading: Cesium.Math.toRadians(Cesium.defaultValue(view.heading, 0)), //绕垂直于地心的轴旋转
          pitch: Cesium.Math.toRadians(Cesium.defaultValue(view.pitch, -90)), //绕纬度线旋转
          roll: Cesium.Math.toRadians(Cesium.defaultValue(view.roll, 0)), //绕经度线旋转
        };
        viewer.camera.flyTo(opts);
      }

      if (row.type == "sceneBookmark") {
        var commoent = Actions[row.type];
        this.$dialog.open({
          id: "编辑动作" + commoent.name,
          title: "编辑动作【" + commoent.name + "】",
          theme: "feature-dialog",
          area: {
            height: "auto",
            width: "400px",
          },
          content: {
            type: "vue",
            subCom: commoent.com,
            subData: row,
          },
        });
        return;
      }
      if (row.type == "commonPlot") {
        this.callbackEdit(row);
        return;
      }
    },

    callbackEdit(row) {
      console.log(row);
      var extType = row.data.extType;
      var typeList = {
        点: {
          name: "点",
          content: com_point,
        },
        图标: {
          name: "图标",
          content: com_billboard,
        },
        线: {
          name: "线",
          content: com_line,
        },
        曲线: {
          name: "曲线",
          content: com_line,
        },
        面: {
          name: "面",
          content: com_polygon,
        },
        面体: {
          name: "面体",
          content: com_polygon3,
        },
        直线箭头: {
          name: "直线箭头",
          content: com_polygon3,
        },
        攻击箭头: {
          name: "攻击箭头",
          content: com_polygon3,
        },
        钳击箭头: {
          name: "钳击箭头",
          content: com_polygon3,
        },
        分队战斗: {
          name: "分队战斗",
          content: com_polygon3,
        },
        突击方向: {
          name: "突击方向",
          content: com_polygon3,
        },
        集结地: {
          name: "集结地",
          content: com_polygon3,
        },
        圆: {
          name: "圆",
          content: com_circle,
        },
        矩形: {
          name: "矩形",
          content: com_rectangle,
        },
        三角形: {
          name: "三角形",
          content: com_polygon,
        },
        球体: {
          name: "球体",
          content: com_ellipsoid,
        },
        圆锥: {
          name: "圆锥",
          content: com_cylinder,
        },
        墙体: {
          name: "墙体",
          content: com_wall,
        },
        管道: {
          name: "管道",
          content: com_polylineVolume,
        },
        军标: {
          name: "军标",
          content: com_svgEdit,
        },
      };

      this.openLayer(typeList[extType].name, typeList[extType].content, row);
    },
    openLayer(type, content, row) {
      var that = this;

      var entity = viewer.entities.getById(row.data.markId);
      if (!entity) {
        return;
      }

      //viewer.zoomTo(entity);

      let deepObj = {
        entity: entity,
        row: row,
        update: function (data) {
          row["name"] = data["name"] || row["name"];
          row["data"] = data["data"] || row["data"];
          that.$forceUpdate(); //强制刷新
        },
      };
      this.$dialog.open({
        title: `属性编辑`,
        theme: "feature-dialog",
        shade: false,
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: content,
          subData: deepObj,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.planEditor-div {
  padding: 0 20px;

  .plan-form {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

  .save-div {
    padding: 20px;
    text-align: center;
  }
}
</style>

<style lang="scss">
.planEditor-div {
  .plan-form {
    .el-input {
      width: calc(100% - 80px);
    }

    .el-select {
      width: calc(100% - 80px);

      .el-input {
        width: calc(100%);
      }
    }

    .hasBtn {
      width: calc(100% - 80px - 74px);

      .el-input {
        width: calc(100% - 10px);
      }
    }
  }

  .isDragBox {
    cursor: move;
    position: relative;
  }
  .active-drag {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: -1px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: #4b79f3;
      z-index: 99;
    }
  }
}
</style>
